import { useState } from 'react';
import { Check, HelpCircle, Send, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui';
import { submitAskQuery } from '../lib/account';

/** Ask a doubt & message-to-teacher share the legacy elearning_AskQueries write. */
export function StudentAskQuery({ variant = 'doubt' }: { variant?: 'doubt' | 'teacher' }) {
  const teacher = variant === 'teacher';
  const [subject, setSubject] = useState(teacher ? 'Message to Teacher' : '');
  const [query, setQuery] = useState('');
  const [state, setState] = useState<'idle' | 'sending' | 'sent'>('idle');
  const [error, setError] = useState('');

  if (state === 'sent') return <div className="utility-page">
    <section className="utility-hero"><div className="utility-icon"><Check size={28} /></div><div><h1>Sent</h1><p>{teacher ? 'Your teacher will see your message soon.' : 'Your question has reached the teaching team.'}</p></div></section>
    <section className="detail-section"><Link to="/my-doubts"><Button variant="soft">View my questions</Button></Link></section>
  </div>;

  return <div className="utility-page">
    <section className="utility-hero"><div className="utility-icon">{teacher ? <Users size={28} /> : <HelpCircle size={28} />}</div><div><h1>{teacher ? 'Message to teacher' : 'Ask a doubt'}</h1><p>{teacher ? 'Write directly to your AyurGuide faculty.' : 'Send a study question to your teaching team.'}</p></div></section>
    <section className="composer-card">
      <label>Subject{!teacher && <span> · required</span>}<input value={subject} onChange={(event) => setSubject(event.target.value)} placeholder="What do you need help with?" /></label>
      <label>Your question<textarea value={query} onChange={(event) => setQuery(event.target.value)} rows={6} placeholder="Add the context — lecture name or test question — so your teacher can help quickly." /></label>
      {error && <small className="field-error">{error}</small>}
      <Button icon={Send} disabled={state === 'sending' || !subject.trim() || !query.trim()} onClick={() => void send()}>{state === 'sending' ? 'Sending…' : 'Send question'}</Button>
    </section>
  </div>;

  async function send() {
    setState('sending'); setError('');
    try {
      await submitAskQuery(subject, query);
      setState('sent');
    } catch (submitError) {
      setState('idle');
      setError(submitError instanceof Error ? submitError.message : 'Could not send your question.');
    }
  }
}
